// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".match-found-modal[data-v-041a1faa] .modal{max-width:min(90vw,32rem)}.match-found-modal__progress-rail[data-v-041a1faa]{stroke:rgba(215,22,36,.2);stroke-dasharray:239.159px,800px;stroke-dashoffset:-37.5px}.match-found-modal__progress-fill[data-v-041a1faa]{stroke:#6dbb1f;stroke-dashoffset:-37.5px;transition:stroke-dasharray 1s linear}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
